import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { ApplicationService } from 'src/app/services/application-service';
import { handleApiError } from 'src/app/utils/error';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
  @Input() label!: string;
  @Input() control!: FormArray;
  @Input() controlName!: string;
  @Input() error: string | null = '';
  @Input() applicationId!: number;
  @Input() uploaderName!: string;
  @Input() uploadedFileLabel!: string;
  @Input() isSummary!: boolean;
  @Input() onlyUpload = false;
  @Input() uploadLabel = '';
  @Input() uploadMoreLabel = '';
  @Input() genericPrefix = '';

  modalOpen!: boolean;
  buttonLabel!: string;
  isDirty = false;
  color!: string;
  constructor(
    private applicationsApiService: ApplicationsApiService,
    private translateService: TranslateService,
    private applicationService: ApplicationService,
    protected trackingService: TrackingService
  ) {}

  ngOnInit(): void {
    this.handleChanges(this.control.value);
    this.control.valueChanges.subscribe((val: Array<FormControl>) => {
      this.handleChanges(val);
    });
  }

  detectFiles(event: any): void {
    const files = event.target.files;
    if (files) {
      for (const file of files) {
        // Add genericPrefix to file
        let data = new FormData();
        data.append('file', file, `${this.genericPrefix}${file.name}`);
        const newFile = data.get('file');

        const reader = new FileReader();
        reader.onload = () => {
          this.control.push(new FormControl(newFile));
          this.handleSave();
        };
        reader.readAsDataURL(file);
      }
    }
  }

  handleChanges(value: Array<FormControl>): void {
    this.setButtonLabel(value);
  }

  setButtonLabel(value: Array<FormControl>): void {
    const uploadLabel = this.uploadLabel ? this.uploadLabel : 'global.upload';
    const uploadMoreLabel = this.uploadMoreLabel
      ? this.uploadMoreLabel
      : 'global.uploadmore';
    this.buttonLabel = value.length > 0 ? uploadMoreLabel : uploadLabel;
  }

  handleSave(): void {
    if (this.control.value.length) {
      this.trackFields('fileUpload' + this.uploaderName);

      this.applicationsApiService
        .addAssetFileToApplication({
          applicationId: this.applicationId,
          name: this.uploaderName,
          data: this.control.value[this.control.length - 1],
        })
        .subscribe(
          () => {
            (this.applicationService as any)[this.controlName] =
              this.control.value;
            this.error = '';
          },
          (error: any) => handleApiError(error, this.translateService)
        );
    }
    this.isDirty = false;
    this.handleChanges(this.control.value);
  }

  trackFields(field: string): void {
    this.trackingService.filledField(field);
  }
}
